<template>
  <div class="label-print-component">
    <div ref="printContent" class="print-root" v-if="showPreview">
      <div
        class="label-container"
        v-for="(cert, index) in certificateList"
        :key="index"
      >
        <div class="label-inner">
          <!-- 标题 -->
          <h3 class="label-title">承诺达标合格证</h3>

          <!-- 承诺区域：隐藏默认◻，用样式替代，统一字号9px -->
          <div class="commitment-area">
            <p class="area-title">我承诺销售的食用农产品:</p>
            <p class="commitment-item">
              <span class="bold-checkbox">☑</span
              >不使用禁用农药兽药、停用兽药和非法添加物
            </p>
            <p class="commitment-item">
              <span class="bold-checkbox">☑</span>常规农药兽药残留不超标
              <span class="checkbox-margin bold-checkbox">☑</span
              >对承诺的真实性负责
            </p>
          </div>

          <!-- 依据区域：隐藏默认◻■√，用样式替代，统一字号9px -->
          <div class="commitment-area">
            <p class="area-title">承诺依据:</p>
            <p class="commitment-item">
              <span class="bold-checkbox">☑</span>质量安全控制符合要求
              <span class="checkbox-margin bold-checkbox">{{
                detectionType.self ? "☑" : "◻"
              }}</span>自行检测合格
              <span class="checkbox-margin bold-checkbox">{{
                detectionType.entrust ? "☑" : "◻"
              }}</span
              >委托检测合格
            </p>
          </div>

          <!-- 分隔线：1px细线 -->
          <div class="divider"></div>

          <!-- 产品信息：字号减1，二维码缩小5px 产地(应具体到乡镇)/生产者盖章(签名) -->
          <div class="info-qrcode-area">
            <div class="product-info">
              <p class="info-item">产品名称:{{ cert.productName }}</p>
              <p class="info-item">重量或数量:{{ cert.spec }}</p>
              <p class="info-item">产地:{{ cert.address }}</p>
              <p class="info-item">生产者:{{ cert.producer }}</p>
              <p class="info-item">联系方式:{{ cert.phone }}</p>
              <p class="info-item">开具日期:{{ cert.date }}</p>
            </div>
            <div class="qrcode-container">
              <div class="qrcode-placeholder" :data-id="cert.id"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  name: "LabelPrint",
  props: {
    certificateList: {
      type: Array,
      required: true,
      // validator: (value) => {
      //   return value.every((item) => {
      //     return (
      //       item.id &&
      //       item.productName &&
      //       item.spec &&
      //       item.address &&
      //       item.producer &&
      //       item.phone &&
      //       item.date
      //     );
      //   });
      // },
    },
    showPreview: {
      type: Boolean,
      default: true,
    },
    detectionType: {
      type: Object,
      default: { self: true, entrust: false },
    },
  },
  methods: {
    getQrcodeUrl(id) {
      // const origin = window.location.origin;
      // return `${origin}/c/${id}`;
      return `https://z.sdmxty.cn/c/${id}`;
    },

    initQrcode(containerSelector = ".qrcode-placeholder") {
      if (!this.showPreview) return;

      const qrcodeContainers = document.querySelectorAll(containerSelector);
      qrcodeContainers.forEach((container) => {
        container.innerHTML = "";
        const id = container.getAttribute("data-id");
        if (!id) return;

        const qrUrl = this.getQrcodeUrl(id);
        // 二维码尺寸调整到60px（70px-5px）
        new QRCode(container, {
          text: qrUrl,
          width: 60,
          height: 60,
          colorDark: "#000",
          colorLight: "#fff",
          correctLevel: QRCode.CorrectLevel.L,
        });

        const canvas = container.querySelector("canvas");
        if (canvas) {
          canvas.style.width = "60px";
          canvas.style.height = "60px";
        }
        const img = container.querySelector("img");
        if (img) {
          img.style.width = "60px";
          img.style.height = "60px";
        }
      });
    },
    cleanupTempElements() {
      // 清理打印临时元素
      const tempContainer = document.getElementById("label-print-temp");
      const tempStyle = document.getElementById("label-print-style");
      if (tempContainer) tempContainer.remove();
      if (tempStyle) tempStyle.remove();
    },
    handlePrint() {
      const printDom = this.$refs.printContent;
      if (!printDom || this.certificateList.length === 0) return;

      // 移除旧临时元素
      this.cleanupTempElements();

      // 创建新临时元素
      const printContainer = document.createElement("div");
      printContainer.id = "label-print-temp";
      printContainer.innerHTML = printDom.innerHTML;
      document.body.appendChild(printContainer);

      // 打印样式：匹配最新需求
      const printStyle = document.createElement("style");
      printStyle.id = "label-print-style";
      printStyle.textContent = `
        @media print {
          body > *:not(#label-print-temp):not(#label-print-style) {
            display: none !important;
          }
          #label-print-temp {
            display: block !important;
            width: 70mm;
            margin: 0 auto;
            padding: 0;
          }
          @page {
            size: 70mm 50mm;
            margin: 0 !important;
          }
          /* 承诺/依据标题字号减1（10px） */
          #label-print-temp .area-title {
            font-size: 10px !important;
          }
          /* 承诺/依据内容字号9px */
          #label-print-temp .commitment-item {
            font-size: 8.5px !important;
            line-height: 1.1 !important;
            color: #000 !important;
          }
          /* 加粗◻样式：无默认符号，纯样式实现 */
          #label-print-temp .bold-checkbox {
            font-weight: bold;
            margin-left: 2px !important; /* ◻前左边距5px */
          }
          /* 第一个◻左边距5px，后续◻额外加10px间距 */
          #label-print-temp .commitment-item .bold-checkbox:first-child {
            margin-left: 2px !important;
          }
          /* 分隔线：1px细线必现 */
          #label-print-temp .divider {
            background-color: #000 !important;
            height: 1px !important;
            display: block !important;
            width: 100% !important;
            margin: 2px 0 !important;
            opacity: 1 !important;
            /* border-top: 1px solid #000 !important; */ 
          }
          /* 内边距 */
          #label-print-temp .label-inner {
            padding: 8px !important;
          }
          #label-print-temp .label-container {
            border: none !important;
          }
          /* 强制左对齐 */
          #label-print-temp .label-inner,
          #label-print-temp .commitment-area,
          #label-print-temp .product-info,
          #label-print-temp .area-title,
          #label-print-temp .commitment-item,
          #label-print-temp .info-item {
            text-align: left !important;
            white-space: nowrap !important;
          }
          #label-print-temp .checkbox-margin {
            margin-left: 4px !important; /* 后续◻额外左边距 */
          }
          /* 产品信息字号减1（9.5px） */
          #label-print-temp .product-info .info-item {
            font-size: 9.5px !important;
            line-height: 1.2 !important;
            margin-bottom: 1px !important;
          }
          /* 二维码尺寸60px */
          #label-print-temp .qrcode-container,
          #label-print-temp .qrcode-placeholder {
            width: 60px !important;
            height: 60px !important;
          }
        }
      `;
      document.head.appendChild(printStyle);

      this.initQrcode("#label-print-temp .qrcode-placeholder");

      // ========== 关键：监听打印预览窗口关闭事件 ==========
      const printMediaQuery = window.matchMedia("print");

      // 监听打印状态变化（打开/关闭预览窗口）
      const handlePrintStateChange = (e) => {
        if (e.matches) {
          // 打印预览窗口打开（可选：记录打开状态）
          // console.log("打印预览窗口已打开");
        } else {
          // 打印预览窗口关闭（无论打印完成/取消）
          // console.log('打印预览窗口已关闭');

          // 1. 向父组件发送信号（可携带状态）// 自定义事件：预览窗口关闭
          this.$emit("print-preview-closed");

          // 2. 清理临时元素
          this.cleanupTempElements();

          // 3. 清理 matchMedia 监听
          printMediaQuery.removeEventListener("change", handlePrintStateChange);
        }
      };

      // 绑定监听事件
      printMediaQuery.addEventListener("change", handlePrintStateChange);

      // 触发打印（打开预览窗口）
      setTimeout(() => {
        window.print();
      }, 200);
    },
  },
  mounted() {
    this.$nextTick(() => this.initQrcode());
  },
  updated() {
    this.$nextTick(() => this.initQrcode());
  },
  beforeDestroy() {
    // 清理 matchMedia 监听
    const printMediaQuery = window.matchMedia("print");
    printMediaQuery.removeEventListener("change", this.handlePrintStateChange);
  },
};
</script>

<style scoped>
/* 组件样式隔离 */
.label-print-component {
  --font-size-title: 15px;
  --font-size-area: 10px; /* 承诺/依据标题字号减1 */
  --font-size-commitment: 8.5px; /* 承诺/依据内容字号 */
  --font-size-info: 9.5px; /* 产品信息字号减1 */
  --checkbox-margin: 4px; /* 后续◻额外左边距 */
  --checkbox-left-padding: 2px; /* ◻前左边距 */
  --inner-padding: 8px; /* 内边距 */
  --qrcode-size: 60px; /* 二维码尺寸 */
}

.label-print-component ::v-deep * {
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  text-align: left !important;
  direction: ltr !important;
  font-family: "SimHei", sans-serif !important;
}

.print-root {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  margin: 20px 0 !important;
}

/* 标签容器 */
.label-container {
  width: 264px; /* 70mm */
  height: 189px; /* 50mm */
  border: 1px solid #ccc;
  box-sizing: border-box;
  overflow: hidden !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 内边距 */
.label-inner {
  width: 100% !important;
  height: 100% !important;
  padding: var(--inner-padding) !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 1px !important;
}

/* 标题 */
.label-title {
  font-size: var(--font-size-title) !important;
  font-weight: bold !important;
  text-align: center !important;
  line-height: 1.2 !important;
  color: #000 !important;
  margin-bottom: 2px !important;
}

/* 承诺/依据标题：字号10px */
.area-title {
  font-size: var(--font-size-area) !important;
  font-weight: bold !important;
  line-height: 1.2 !important;
  color: #000 !important;
  margin-bottom: 2px !important;
}

/* 承诺/依据区域 */
.commitment-area {
  width: 100% !important;
}

/* 承诺/依据内容：字号9px */
.commitment-item {
  font-size: var(--font-size-commitment) !important;
  line-height: 1.2 !important;
  color: #000 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  margin-bottom: 1px !important;
}

/* 加粗◻ */
.bold-checkbox {
  font-weight: bold;
  margin-left: var(--checkbox-left-padding) !important; /* ◻前左边距5px */
  /* vertical-align: middle !important; */
}

/* 同一行后续◻的额外左边距 */
.checkbox-margin {
  margin-left: var(--checkbox-margin) !important;
}

/* 分隔线：1px细线必现 */
.divider {
  background-color: #000 !important;
  height: 1px !important;
  width: 100% !important;
  display: block !important;
  position: relative !important;
  z-index: 999 !important;
  margin: 2px 0 !important;
  opacity: 1 !important;
  /* border-top: 1px solid #000 !important; */
  border-bottom: none !important;
}

/* 产品信息+二维码 */
.info-qrcode-area {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 5px !important;
  width: 100% !important;
  margin-top: 2px !important;
}

.product-info {
  width: 73% !important;
  font-size: var(--font-size-info) !important;
  line-height: 1.2 !important;
  color: #000 !important;
}

.info-item {
  line-height: 1.2 !important;
  margin-bottom: 1px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* 二维码容器：60px */
.qrcode-container {
  width: var(--qrcode-size) !important;
  height: var(--qrcode-size) !important;
  flex-shrink: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  /* border: 1px solid #ccc !important; */
}

.qrcode-placeholder {
  width: var(--qrcode-size) !important;
  height: var(--qrcode-size) !important;
}
</style>
